import { Breadcrumbs, ContactForm } from "@/components/features/logTicket";
import Footer from "../../components/common/layout/Footer";
import SEO from "@/components/common/seo/seo";

export default function LogTicket() {
    return (
        <div>
            <SEO
                title="Log a Ticket - SAN micron"
                description="Need assistance? Log a support ticket with SAN micron and our team will get back to you promptly to resolve your issues."
            />
            <Breadcrumbs />
            <ContactForm />
            <div className="abstract-bg">
                {/* <FAQ /> */}
            </div>
            <Footer />
        </div>
    );
}